export const CONFIDENCE_THRESHOLD = 0.1
export const NOTICE_MESSAGE = "We are updating our servers to offer you a better experience. You may experience a momentary disruption in the performance because of the updating process. Don't worry, any disruption due to updating will not last more than two hours. Thank you for your understanding."

export const host = 'http://api.wide-eyes.it'
export const hostApiMirror = 'http://v5.api-mirror.wide-eyes.it'
export const eventsHost = 'http://events-engine.wide-eyes.it';
export const version = "v3.2"
export const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

export const attributesMap = {
  tshirt: [
    'style', 'sleeve length', 'pattern type', 'color', 'neckline'
  ],
  skirt: [
    'style', 'silhouette', 'pattern type', 'color', 'clothes length', 'dress/skirt silhouette', 'dress/skirt length', 'embellishments'
  ],
  jeans: [
    'silhouette', 'color', 'pants silhouette', 'pattern type', 'pants length', 'embellishments', 'waist skirts/pants'
  ],
  'short pants': [
    'pants silhouette', 'pattern type', 'color', 'pants length', 'embellishments', 'waist skirts/pants'
  ],
  shorts: [
    'style', 'pattern type', 'color', 'clothes length', 'pants silhouette', 'pants length', 'embellishments', 'waist skirts/pants'
  ],
  cardigan: [
    'style', 'pattern type', 'color', 'neckline', 'sleeve length', 'tops silhouette', 'neckline shape', 'neckline depth', 'embellishments'
  ],
  basic: [
    'style', 'pattern type', 'color', 'toe shape'
  ],
  gladiator: [
    'style',
    'pattern type',
    'color',
    'toe shape',
    'heel height',
    'heel type'
  ],
  'mary janes': [
    'style',
    'pattern type',
    'color',
    'toe shape',
    'heel height',
    'heel type'
  ],
  slingbacks: [
    'style',
    'pattern type',
    'color',
    'toe shape',
    'heel height',
    'heel type'
  ],
  top: [
    'style',
    'sleeve length',
    'pattern type',
    'color',
    'silhouette',
    'neckline'
  ],
  tops: [
    'tops silhouette', 'sleeve length', 'pattern type', 'color', 'neckline depth', 'neckline shape'
  ],
  jacket: [
    'style', 'pattern type', 'color', 'neckline', 'sleeve length', 'embellishments'
  ],
  sweater: [
    'style', 'pattern type', 'color', 'neckline', 'sleeve length', 'tops silhouette', 'neckline shape', 'neckline depth', 'embellishments'
  ],
  dress: [
    'style',
    'pattern type',
    'color',
    'neckline',
    'sleeve length',
    'silhouette',
    'clothes length',
    'neckline depth', 'embellishments', 'dress/skirt silhouette', 'dress/skirt length', 'neckline shape'
  ],
  shirt: [
    'style', 'pattern type', 'color', 'neckline', 'sleeve length', 'tops silhouette', 'neckline depth', 'neckline shape'
  ],
  'shoulder bag': [
    'style', 'pattern type', 'color'
  ],
  clutch: [
    'style', 'pattern type', 'color'
  ],
  bag: [
    'style', 'pattern type', 'color'
  ],
  'glasses/sunglasses': [
    'pattern type', 'color', 'embellishments'
  ],
  hats: [
    'pattern type', 'color', 'embellishments'
  ],
  jewelery: [
    'pattern type', 'color', 'embellishments'
  ],
  belts: [
    'pattern type', 'color', 'embellishments'
  ],
  'other accessories': [
    'pattern type', 'color', 'embellishments'
  ],
  backpack: [
    'style', 'pattern type', 'color', 'embellishments'
  ],
  duffle: [
    'style', 'pattern type', 'color'
  ],
  coat: [
    'style', 'pattern type', 'color', 'neckline', 'sleeve length'
  ],
  'coat/cape': [
    'sleeve length', 'pattern type', 'color', 'embellishments'
  ],
  'pump/wedge': [
    'pattern type', 'color', 'heel height', 'toe shape', 'heel style', 'embellishments'
  ],
  flat: [
    'pattern type', 'color', 'toe shape', 'embellishments'
  ],
  sandals: [
    'pattern type', 'color', 'heel height', 'toe shape', 'heel style', 'embellishments'
  ],
  boots: [
    'style',
    'pattern type',
    'color',
    'toe shape',
    'boot height',
    'heel height', 'boot height', 'heel style'
  ],
  'riding boots': [
    'style',
    'pattern type',
    'color',
    'toe shape',
    'boot height',
    'heel height'
  ],
  'snow boots': [
    'style',
    'pattern type',
    'color',
    'toe shape',
    'boot height',
    'heel height'
  ],
  leggings: [
    'style', 'pattern type', 'color'
  ],
  cape: [
    'style', 'pattern type', 'color'
  ],
  pants: [
    'style', 'pattern type', 'color', 'pants silhouette', 'pants length', 'embellishments', 'waist skirts/pants'
  ],
  joggers: [
    'pants silhouette', 'pattern type', 'color', 'pants length', 'embellishments', 'waist skirts/pants'
  ],
  vest: [
    'sleeve length', 'pattern type', 'color', 'embellishments'
  ],
  blouse: [
    'style', 'sleeve length', 'pattern type', 'color', 'neckline'
  ],
  sweatshirt: [
    'style', 'sleeve length', 'pattern type', 'color'
  ],
  'baseball caps': [
    'style', 'pattern type', 'color'
  ],
  beanie: [
    'style', 'pattern type', 'color'
  ],
  beret: [
    'style', 'pattern type', 'color'
  ],
  'brimmed hat': [
    'style', 'color'
  ],
  'bucket hats': [
    'style', 'color'
  ],
  'trapper hat': [
    'style', 'color'
  ],
  visors: [
    'style', 'color'
  ],
  polo: [
    'tops silhouette', 'sleeve length', 'pattern type', 'color', 'neckline depth', 'neckline shape'
  ],
  suits: [
    'sleeve length', 'neckline depth', 'pattern type', 'color', 'embellishments', 'pants silhouette', 'pants length', 'neckline shape'
  ],
  jumpsuits: [
    'sleeve length', 'neckline depth', 'pattern type', 'color', 'embellishments', 'pants silhouette', 'pants length', 'neckline shape'
  ],
  blazer: ['style', 'sleeve length', 'pattern type', 'color', 'sleeve length', 'embellishments'
  ],
  'clutch/wallet': [
    'pattern type', 'color', 'embellishments'
  ],
  'crossbody/bagmessenges': [
    'pattern type', 'color', 'embellishments'
  ],
  'crossbody/bag': [
    'pattern type', 'color', 'embellishments'
  ],
  'crossbody/messenger': [
    'pattern type', 'color', 'embellishments'
  ],
  'briefcase': [
    'pattern type', 'color', 'embellishments'
  ],
  'top handles': [
    'pattern type', 'color', 'embellishments'
  ],
  'travel bags': [
    'pattern type', 'color', 'embellishments'
  ],
  'pants/leggings': [
    'pants silhouette', 'pattern type', 'color', 'pants length', 'embellishments', 'waist skirts/pants'
  ]
}




// WEBPACK FOOTER //
// ./src/shared/constants.js